import type { JSX } from "react";
import rhyt_rest_4 from "./rhyt-rest-4";
import rhyt_rest_4d from "./rhyt-rest-4d";
import rhyt_rest_8 from "./rhyt-rest-8";
import rhyt_rest_16 from "./rhyt-rest-16";
import rhyt_ri from "./rhyt-ri";
import rhyt_riri from "./rhyt-riri";
import rhyt_riririri from "./rhyt-riririri";
import rhyt_ririririti from "./rhyt-ririririti";
import rhyt_tiriririri from "./rhyt-tiriririri";
import rhyt_rirititi from "./rhyt-rirititi";
import rhyt_ririti from "./rhyt-ririti";
import rhyt_ritim from "./rhyt-ritim";
import rhyt_ritimti from "./rhyt-ritimti";
import rhyt_ta_a_a_a from "./rhyt-ta-a-a-a";
import rhyt_ta_a_a_a_a_a from "./rhyt-ta-a-a-a-a-a";
import rhyt_ta_a from "./rhyt-ta-a";
import rhyt_ta_a_a from "./rhyt-ta-a-a";
import rhyt_ta from "./rhyt-ta";
import rhyt_tam from "./rhyt-tam";
import rhyt_ti from "./rhyt-ti";
import rhyt_timri from "./rhyt-timri";
import rhyt_timriti from "./rhyt-timriti";
import rhyt_tiriri from "./rhyt-tiriri";
import rhyt_titi from "./rhyt-titi";
import rhyt_titiriri from "./rhyt-titiriri";
import rhyt_tititi from "./rhyt-tititi";
import rhyt_rest_1 from "./rhyt-rest-1";
import rhyt_rest_2 from "./rhyt-rest-2";
import rhyt_truplet from "./rhyt-truplet";
import rhyt_titititi from "./rhyt-titititi";

export default {
    rhyt_rest_4,
    rhyt_rest_4d,
    rhyt_rest_8,
    rhyt_rest_16,
    rhyt_ri,
    rhyt_riri,
    rhyt_riririri,
    rhyt_ririti,
    rhyt_ritim,
    rhyt_ta_a_a_a_a_a,
    rhyt_ta_a_a_a,
    rhyt_ta_a,
    rhyt_ta_a_a,
    rhyt_ta,
    rhyt_tam,
    rhyt_ti,
    rhyt_timri,
    rhyt_tiriri,
    rhyt_titi,
    rhyt_tititi,
    rhyt_ririririti,
    rhyt_tiriririri,
    rhyt_rirititi,
    rhyt_ritimti,
    rhyt_timriti,
    rhyt_titiriri,
    rhyt_rest_1,
    rhyt_rest_2,
    rhyt_truplet,
    rhyt_titititi,
} as {[rhytName: string]: () => JSX.Element};
